
export default[
    {
        "entity": {
            "id": 1,
            "name": "userManage",
            "path": "/vehiclePosition",
            "icon": "el-icon-news",
            "alias": "个人中心",
            "discription": "个人中心",
        },
        "childs": [
            {
                "entity": {
                    "id": 2,
                    "name": "staff",
                    "path":"/user/staff",
                    "icon": "el-icon-phone-outline\r\n",
                    "alias": "身份认证",
                    "discription": "员工中心",
                },
                "childs": null
            },
        ]
    },
]